/**
 * Created by frank.law on 11/15/17.
 */
import React from 'react';
import '../../../css/login.css';
import {Control} from 'react-redux-form';
import PropTypes from 'prop-types';

export const MAXIMUM_USERNAME_LENGTH = '254';

class UsernameField extends React.Component {

    onChange(event) {
        const {onChangeFunc} = this.props;
        onChangeFunc(event.target.value);
    }

    render() {
        const {defaultValue, label, placeholder, isError} = this.props;
        let usernameFieldStyle = "wdc-form-textinput";
        usernameFieldStyle += (isError) ? " wdc-form-error" : "";
        const ControlText = Control.text;

        return (
            <div className="wdc-form-field-wrapper">
                <label className="wdc-form-label wdc-form-label-required">{label}</label>
                <div className="wdc-form-field">
                    <ControlText maxLength={MAXIMUM_USERNAME_LENGTH} autoFocus aria-label={label} model='.username' className={usernameFieldStyle} placeholder={placeholder} id="username" onChange={this.onChange.bind(this)} defaultValue={defaultValue}/>
                </div>
            </div>
        );
    }
}

UsernameField.propTypes = {
    onChangeFunc: PropTypes.func,
    defaultValue: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    isError: PropTypes.bool
};

export default UsernameField;
